module.exports = __webpack_public_path__ + "static/media/gobierno-corporativo.8b73d7fc.jpg";